import React, { useEffect } from 'react';
import { convenios_item } from '../../json/conveniosItem';
import './convenios.css';




const Convenios = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container convenios-container'>
            <div className='row'>
                <h3 className='title'>Convenios para Trabajadores de Gobierno del Estado de Hidalgo</h3>
                <hr className='hr-gob' />
                <h6>La Oficialía Mayor pone a disposición de los trabajadores del Estado de Hidalgo, la relación de las instituciones educativas
                    y empresas privadas con las que se tiene convenio para descuentos.</h6>
                <h6>Para hacer valido el descuento en instituciones educativas deberá enviar un correo electronico a la siguiente dirección:</h6>
                <h5>convenios.institucionales@hidalgo.gob.mx</h5>
            </div>
            <div className='row'>
                <div className='list-group'>
                    <a className="list-group-item list-group-item-action flex-column align-items-start ">
                        <div className="d-flex w-100 justify-content-between">
                            <div className='convenios_item'>
                                <h5  >Datos que deberán poner en el cuerpo del correo</h5>
                            </div>
                        </div>
                        <p ><strong>Del trabajador </strong>  <small className='text-muted'>Nombre, edad, categoria, nivel, puesto y teléfono</small></p>
                        <p ><strong>Del beneficiario  </strong> <small className='text-muted'>Nombre, edad y parentesco con el trabajador</small></p>
                        <p ><strong>De la escuela  </strong> <small className='text-muted'>Nombre, y estudios a realizar (grado, semestre o cuatrimestre según sea el caso)</small></p>

                    </a>
                    <a className="list-group-item list-group-item-action flex-column align-items-start ">
                        <div className="d-flex w-100 justify-content-between">
                            <div className='convenios_item'>
                                <h5  >Documentos escaneados en el correo</h5>
                            </div>
                        </div>
                        <p ><strong>Del trabajador </strong>  <small className='text-muted'>Último recibo de nómina</small></p>
                        <p ><strong>Del hijo (a)  </strong> <small className='text-muted'>Acta de nacimiento</small></p>
                        <p ><strong>Del conyúge </strong> <small className='text-muted'>Acta de matrimonio</small></p>
                        <p ><strong>Del dependiente económico </strong> <small className='text-muted'>Carta de dependencia económica expedida por la Presidencia Municipal que le corresponda</small></p>
                    </a>
                </div>
            </div>

            <br>
            </br>
            <br>
            </br>
            <div className='row'>
                {
                    convenios_item.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-3'>
                            <a href={item.url} >
                                    <img src={"/assets/imgs/" + item.icono} className='card-img-top-convenios' alt=''>
                                    </img>
                            </a>
                                <br></br>
                                <br></br> 
                       
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Convenios